import React from 'react';

const Notification = ({ id, model, autoClose = true, onDelete, timeToClose = 4000 }) => {

    React.useEffect(() => {
        if (autoClose) {
            const timeoutId = setTimeout(() => close(), timeToClose);

            return () => {
                clearTimeout(timeoutId);
            };
        }
    }, [autoClose]);

    const close = () => {
        if (onDelete) onDelete(id);
    }

    return (
        <div className='notification' onClick={close}>
            {(model.type === "Achievement") && (
                <div className="achievement" >
                    <img src={model.image} />
                    <div className='points'>{model.points}</div>
                    <div className='title'>{model.title}</div>
                    <div className='description' >{model.description}</div>
                </div>
            )}
            {(model.type !== "Achievement") && (
                <div className='notificationItem'>{model.message}</div>
            )}
        </div>
    );
}



const Notifications = React.forwardRef(({timeToClose}, ref) => {
    const [toasts, setToasts] = React.useState([]);

    React.useImperativeHandle(ref, () => ({
        createToast(model) {
            setToasts((currentToasts) => [
                ...currentToasts,
                {
                    id: (Math.random() * 10000000),
                    model: model
                }
            ]);

        }
    }));

    const close = (id) => {
        setToasts((currentToasts) =>
            currentToasts.filter((toast) => toast.id !== id)
        );
    }


    return (
        <div className="notifications">
            {toasts.map((item) => (
                <Notification key={item.id} id={item.id} model={item.model} onDelete={close} timeToClose={timeToClose} />
            ))}
        </div>
    )
});



export default Notifications;

